import {useIsInitialLocation} from '@aboutyou/router';
import {useIsomorphicLayoutEffect} from '@aboutyou/ui-components';
import {useRef} from 'react';
import {useIsBannerOpen} from './useIsBannerOpen';

export const useHideInstallBannerOnPage = () => {
  const isInitialLocation = useIsInitialLocation();
  const {isOpen, close, open} = useIsBannerOpen();
  const isTemporarilyHidden = useRef(false);

  useIsomorphicLayoutEffect(() => {
    if (isInitialLocation && isOpen) {
      close({disableAnimation: true});
      isTemporarilyHidden.current = true;
    }
  }, [isInitialLocation, isOpen]);

  // on mount
  useIsomorphicLayoutEffect(() => {
    if (isInitialLocation) return;

    if (isOpen) {
      close();
      isTemporarilyHidden.current = true;
    }
  }, [isOpen]);

  // on unmount
  useIsomorphicLayoutEffect(
    () => () => {
      if (isTemporarilyHidden.current) {
        open();
      }
    },
    [],
  );
};
